import { useState, forwardRef, useImperativeHandle } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

/**
 * PlatformCheckbox component.
 *
 * This component renders a checkbox with label and provides imperative methods to interact with it.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.optionText - Text for the checkbox label.
 * @param {boolean} props.check - Initial checked state of the checkbox.
 * @param {any} props.scraperOption - Additional option data associated with the checkbox.
 * @param {React.RefObject} ref - Ref to access imperative methods.
 *
 * @returns {JSX.Element} - The JSX element for the checkbox.
 */
const PlatformCheckbox = forwardRef(function PlatformCheckbox({ label, initialChecked, scraperOption }, ref) {
  const [isChecked, setIsChecked] = useState(initialChecked);

  const toggleCheckbox = () => {
    setIsChecked(!isChecked);
  };

  useImperativeHandle(
    ref,
    () => ({
      getPlatformState: () => ({ name: label, selected: isChecked, scraperOption: scraperOption }),
      setUnchecked: () => setIsChecked(false),
      setChecked: () => setIsChecked(true),
    }),
    [isChecked, label, scraperOption]
  );
  // console.log(scraperOption);
  
  return <FormControlLabel control={<Checkbox checked={isChecked} onChange={toggleCheckbox} />} label={label} />;
});

export default PlatformCheckbox;
